function __MN_KL(klaviyo_list_id, cors_url, data_json) {
    return new Promise(function(resolve, reject) {
      
        var xmlhttp = new XMLHttpRequest
          , theUrl = cors_url + "https://a.klaviyo.com/api/profiles/";
        xmlhttp.open("POST", theUrl),
        xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8"),
        xmlhttp.setRequestHeader("X-Requested-With", "*"),
        xmlhttp.setRequestHeader("Authorization", `Klaviyo-API-Key pk_c946449495d8793e27836dbc907ac7ea40`),
        xmlhttp.setRequestHeader("revision", "2024-02-15"),
        xmlhttp.send(JSON.stringify({
            data: {
              "type": "profile",
              "attributes": {
                "email": data_json.email,
              }
            }
        })),
        xmlhttp.onload = function() {
            var return_data = {
                status: xmlhttp.status,
                data: JSON.parse(xmlhttp.response)
            };
            return resolve(return_data)
        }
    })
}
//# sourceMappingURL=/s/files/1/0579/0626/6309/files/matt_nikita.js.map
